export default __webpack_public_path__ + "static/media/agenda-text-hover.32454112.png";